import React from 'react';
import PropTypes from 'prop-types';

const LoadableFallbackView = () => (
  <div className="fixed inset-0 z-50 grid place-items-center bg-[color-mix(in_srgb,var(--owner-page-bg)_78%,transparent)] backdrop-blur-sm">
    <span
      aria-label="Loading"
      className="inline-block h-8 w-8 animate-spin rounded-full border-2 border-[var(--owner-border)] border-t-[var(--tenant-primary)]"
      role="status"
    />
  </div>
);

export const LoadableFallback = ({ visible }) => (visible ? <LoadableFallbackView /> : null);

LoadableFallback.propTypes = {
  visible: PropTypes.bool,
};

export default LoadableFallbackView;
